import React from 'react';
import { Box, Container, Typography, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: 'secondary.main',
        color: '#fff',
        py: 4,
        mt: 'auto',
        // Only apply bottom positioning on medium and larger screens
        width: '100%',
      }}
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography variant="body2" sx={{ mb: 2 }}>
          © {new Date().getFullYear()} MindMapper AI. All rights reserved.
        </Typography>
        <Box>
          <MuiLink component={Link} to="/privacy" color="inherit" underline="hover" sx={{ mx: 1 }}>
            Privacy Policy
          </MuiLink>
          <MuiLink component={Link} to="/terms" color="inherit" underline="hover" sx={{ mx: 1 }}>
            Terms & Conditions
          </MuiLink>
          <MuiLink component={Link} to="/contact" color="inherit" underline="hover" sx={{ mx: 1 }}>
            Contact
          </MuiLink>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
